const SvgCloud2 = (props) => (
  <>
    <path
      fill={props.p20}
      opacity={0.5}
      d="M96 72V24L56 0 16 24v48l40 24 40-24zM96 264v-48l-40-24-40 24v48l40 24 40-24zM176 168v-48l-40-24-40 24v48l40 24 40-24zM176 360v-48l-40-24-40 24v48l40 24 40-24z"
    />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M99.42 93.95 136 72V24L96 0 56 24v48l36.58 21.95M92.58 98.05 56 120v48l36.58 21.95M99.42 189.95 136 168v-48L99.42 98.05M99.42 194.05 136 216v48l-36.58 21.95M92.58 285.95 56 264v-48l36.58-21.95M99.42 290.05 136 312v48l-40 24-40-24v-48l36.58-21.95M99.42 194.05c.36-.6.58-1.3.58-2.05s-.22-1.45-.58-2.05M99.42 194.05c-.7 1.16-1.96 1.95-3.42 1.95s-2.72-.79-3.42-1.95M92.58 189.95c-.36.6-.58 1.3-.58 2.05s.22 1.45.58 2.05M99.42 189.95c-.7-1.16-1.96-1.95-3.42-1.95s-2.72.79-3.42 1.95M92.58 93.95c-.36.6-.58 1.3-.58 2.05s.22 1.45.58 2.05M99.42 98.05c-.7 1.16-1.96 1.95-3.42 1.95s-2.72-.79-3.42-1.95M99.42 98.05c.36-.6.58-1.3.58-2.05s-.22-1.45-.58-2.05"
    />
    <path
      d="M92.58 93.95C93.28 92.79 94.54 92 96 92s2.72.79 3.42 1.95M92.58 285.95c.7-1.16 1.96-1.95 3.42-1.95s2.72.79 3.42 1.95M99.42 290.05c-.7 1.16-1.96 1.95-3.42 1.95s-2.72-.79-3.42-1.95M99.42 290.05c.36-.6.58-1.3.58-2.05s-.22-1.45-.58-2.05M92.58 285.95c-.36.6-.58 1.3-.58 2.05s.22 1.45.58 2.05"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
  </>
);

export default SvgCloud2;
